import createFetchClient, { type Middleware } from "openapi-fetch";

import type { paths } from "../openapi";
import { getCredentialsHeaders } from "./credentials.ts";

export interface Urls {
  /** Standard HTTP for REST and GraphQL */
  api: string;
  /** Web Sockets */
  ws: string;
  /** Application context path */
  basePath: string;
  /** External OpenAPI documentation */
  xapi: string;
}

export type ApiClient = ReturnType<typeof createApiClient>;

let globalClient: ApiClient | null = null;
let globalUrls: Urls | null = null;

const mainThreadMiddleware: Middleware = {
  async onRequest({ request }) {
    const headers = getCredentialsHeaders();

    for (const [key, value] of headers) {
      request.headers.set(key, value);
    }

    return request;
  },
  async onError({ error }) {
    throw error;
  },
};

export function createApiClient(urls: Urls, withMiddleware = true) {
  const client = createFetchClient<paths>({
    baseUrl: urls.api,
    querySerializer: {
      array: {
        style: "form",
        explode: false,
      },
    },
  });

  if (withMiddleware) {
    client.use(mainThreadMiddleware);
  }

  return client;
}

export function initializeClient(urls: Urls, withMiddleware = true) {
  globalUrls = urls;
  globalClient = createApiClient(urls, withMiddleware);
  return globalClient;
}

export function getClient(): ApiClient {
  if (!globalClient) {
    throw new Error("Something wrong happened. Please refresh the page.");
  }

  return globalClient;
}

export function getUrls(): Urls {
  if (!globalUrls) {
    throw new Error("Something wrong happened. Please refresh the page.");
  }

  return globalUrls;
}
